"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
// eslint-disable-next-line import/prefer-default-export
exports.objFromListWith = ramda_1.curry(function (fn, list) { return ramda_1.chain(ramda_1.zipObj, ramda_1.map(fn))(list); });
//# sourceMappingURL=ObjFromListWith.js.map